module.exports = __webpack_public_path__ + "media/application/images/icons/lock-d20d438ab5b8b69b118b8ac7456f8c50.svg";